import { useContext } from "react";
import { I18nContext } from "../../../../../../context/i18n.context";

interface CancelPolicyLinkProps {
  onCancel: () => void;
}

const CancelPolicyLink = ({ onCancel }: CancelPolicyLinkProps) => {
  const {
    state: { translate },
  } = useContext(I18nContext);

  return (
    <div style={{ textAlign: "center", paddingTop: 8 }}>
      <button
        onClick={onCancel}
        style={{
          border: "none",
          background: "none",
          cursor: "pointer",
          color: "#9ca3af",
          fontSize: 14,
          fontWeight: 500,
          padding: "8px 0",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = "#ef4444";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = "#9ca3af";
        }}
      >
        {translate("newDashboard.retention.cancelPolicy")}
      </button>
    </div>
  );
};

export default CancelPolicyLink;
